import { compose } from 'ramda';

import { toNotFound, redirectTo } from '../../../../store/location/actions';
import { selectParams } from '../../../../store/location/selectors';
import { selectTimeZone } from '../../../../store/intl/selectors';
import { getJoinGameAction } from '../../../game-utils/get-join-game-action';
import { checkJoinability, query } from '../../../game-utils/check-joinability';
import { appendParams } from '../../../url-builders/url-utils';

export const path = '/game-landing/:gameId';

export const component = 'Loading';

export const thunk =
  ({ graphqlClient }) =>
  async (dispatch, getState) => {
    const state = getState();
    const { gameId, product, ...otherParams } = selectParams(state);
    const gameType = product === 'waybetter' ? 'falkor' : product;
    const timeZone = selectTimeZone(state);

    if (!gameId || !gameType || !timeZone) dispatch(toNotFound());

    const { data, error } = await graphqlClient.query({
      query,
      fetchPolicy: 'network-only',
      variables: { gameId, gameIdAsID: gameId, gameType, timeZone },
    });
    const game = data?.game || {};

    if (error) {
      dispatch(toNotFound());
      return;
    }

    const { dependsOnMembership, membershipOfferId, potentiallyJoinable } =
      await checkJoinability(game);
    const nextStep =
      !!potentiallyJoinable &&
      getJoinGameAction({
        gameId,
        gameType,
        membershipOfferId,
        redirectToMembership: dependsOnMembership,
        theme: product,
      });

    if (nextStep) {
      compose(dispatch, redirectTo, appendParams(otherParams))(nextStep);
      return;
    }

    dispatch(toNotFound());
  };
